import LoginFormContainer from './LoginFormContainer';

export default LoginFormContainer;
